/* eslint-disable no-console */
import React, { useState, useEffect } from "react";
import { Row, Col, Dropdown, Menu, Button, message } from "antd";
import { DownOutlined } from "@ant-design/icons";
import { NavigationMenuCard } from "../../../components/ui";
import Layout from "../../../layouts/MocoLayout";
import { TableCard } from "../../../components/widget";
import oRest from "../../../apis/rest";
import config from "./index.config";

const API_URL = "webhook/dataquery/?qname=";

const Page = () => {
  const [cards, setCards] = useState(config.cards);
  const [year, setYear] = useState("2020");

  useEffect(() => {
    const fetchData = async () => {
      try {
        const { data } = await oRest.get(
          `${API_URL}kemenag_all_index_by_year&year=${year}`
        );

        setCards((card) => ({
          ...card,
          table: {
            ...card.table,
            detail: {
              ...card.table.detail,
              content: {
                ...card.table.detail.content,
                subtitle: `Detail Data Tahun ${year}`,
              },
              options: {
                ...card.table.detail.options,
                dataSource: data
                  .filter((e) => e.provinsi !== "NASIONAL")
                  .map((e, idx) => ({ ...e, id: idx })),
              },
              state: {
                data,
              },
            },
          },
        }));
      } catch (error) {
        console.log(error);
        message.error("Terjadi Kesalahan");
      }
    };

    fetchData();
  }, [year]);

  const handleChangeYearMenu = (e) => {
    setYear(e.key);
  };

  const yearMenu = (
    <Menu>
      <Menu.Item onClick={handleChangeYearMenu} key="2019">
        2019
      </Menu.Item>
      <Menu.Item onClick={handleChangeYearMenu} key="2020">
        2020
      </Menu.Item>
      <Menu.Item onClick={handleChangeYearMenu} key="2021">
        2021
      </Menu.Item>
      <Menu.Item onClick={handleChangeYearMenu} key="2022">
        2022
      </Menu.Item>
    </Menu>
  );

  return (
    <Layout>
      <NavigationMenuCard
        menu={[
          { title: "Indeks Karakter", path: "/indeks-karakter-siswa/1" },
          { title: "Peta Sebaran", path: "/indeks-karakter-siswa/2" },
          { title: "Detail Data", path: "/indeks-karakter-siswa/3" },
        ]}
      />
      <Row
        align="top"
        justify="center"
        gutter={[0, 12]}
        style={{
          marginTop: 24,
          marginBottom: 24,
        }}
      >
        <Col span={24}>
          <Row justify="end">
            <Dropdown overlay={yearMenu}>
              <Button
                size="large"
                shape="round"
                style={{
                  backgroundColor: "#1B6FBA",
                  color: "#fff",
                }}
              >
                Pilih tahun &nbsp;
                <DownOutlined />
              </Button>
            </Dropdown>
          </Row>
        </Col>
        <Col span={24}>
          <TableCard {...cards.table.detail} />
        </Col>
      </Row>
    </Layout>
  );
};

export default Page;
